exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".frameTabs .el-submenu .el-menu-item{background-color:#021633!important}.frameTabs .el-submenu .el-menu-item:hover{background-color:rgba(24,144,255,.01)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19e4c117","scoped":false,"hasInlineConfig":false}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=2!./src/components/layout/Frame.vue
// module id = 1113
// module chunks = 45